import React, { memo } from 'react';

interface GroOneFAQProps {
  faqData: any;
}

const GroOneFAQ: React.FC<GroOneFAQProps> = memo(({ faqData }) => {
  return (
    <section id="faq" className="faq section light-background">
      <div className="container-fluid">
        <div className="row gy-4">
          <div className="offset-lg-1 col-lg-10 d-flex flex-column justify-content-center order-2 order-lg-1">
            <div className="content px-xl-5" data-aos="fade-up" data-aos-delay="100">
              <h3>
                <span>{faqData?.data?.title}</span>
              </h3>
              <p dangerouslySetInnerHTML={{ __html: faqData?.data?.description }} />
            </div>

            <div className="accordion faq-container px-xl-5" id="accordionPanelsStayOpenExample">
              {faqData?.data?.accordion?.map((item: any, index: number) => (
                <div className="accordion-item faq-item" key={index} data-aos="fade-up" data-aos-delay="100">
                  <h2 className="accordion-header">
                    {/* <button 
                      className="accordion-button" 
                      type="button" 
                      data-bs-toggle="collapse" 
                      data-bs-target={`#accordion${item.entity_id}`} 
                      aria-expanded="true" 
                      aria-controls={`accordion${item.entity_id}`} 
                      dangerouslySetInnerHTML={{ __html: item.ac_title }} 
                    /> */}
                    <button 
                      className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`} // handle first open item
                      type="button" 
                      data-bs-toggle="collapse"
                      data-bs-target={`#accordion${item.entity_id}`} 
                      aria-expanded={index === 0 ? 'true' : 'false'}
                      aria-controls={`accordion${item.entity_id}`} 
                      dangerouslySetInnerHTML={{ __html: item.ac_title }} 
                    /> 
                  </h2>
                  <div 
                    id={`accordion${item.entity_id}`} 
                    className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                  >
                    <div 
                      className="accordion-body" 
                      dangerouslySetInnerHTML={{ __html: item.ac_desc }} 
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

GroOneFAQ.displayName = 'GroOneFAQ';

export default GroOneFAQ;
